import { useParams } from 'react-router-dom';
import ScreenStub from '@/components/shell/ScreenStub';

export default function DepositCollection() {
  const { depositId } = useParams<{ depositId: string }>();
  return (
    <ScreenStub
      title="Deposit Collection"
      prdSection="§12.14"
      description="One deposit ledger. Stripe Payment Links generated programmatically. Replaces Inkbook + manual logs."
      routeParam={{ name: 'depositId', value: depositId }}
    />
  );
}
